import { SolidButton } from "@components/atoms/base-button";
import { convertToTags } from "@models/interactions/convert-to-tags";
import useHidden from "@models/interactions/use-hidden";
import classNames from "classnames";

export function useIntroduction() {

  function dateConverter(date: string) {
    const splitDate = date.split("-");

    const newDate = splitDate[1] + "/" + splitDate[2] + "/" + splitDate[0];

    return newDate;
  }

  return {
    operations: {
      dateConverter
    },
  };
}

export default function Introduction({
  productLogo,
  introduction,
  button,
  publicationDate,
  subtitle,
}: {
  publicationDate?: string;
  productLogo?: string;
  introduction?: string;
  button?: { buttonCta?: string; buttonLink?: string | undefined };
  subtitle?: string;
}) {
  const { operations } = useIntroduction();

  return (
    <article className="max-sm:w-full flex flex-col">
      <p
        className={classNames(
          "flex md:w-[408px] text-[#737373] justify-start max-sm:text-sm md:text-[15px] lg:text-[15px] xl:text-lg text-left max-sm:pb-[26px] md:pb-[35px] lg:pb-[35px] xl:pb-[41px]",
          useHidden(publicationDate)
        )}
      >
        {operations.dateConverter(publicationDate)}
      </p>
      <div className="flex flex-col max-sm:gap-y-5 md:gap-y-[45px] xl:gap-y-[50px]">
        <h1
          className={classNames(
            "font-chivo-regular max-sm:text-xl lg:text-3xl",
            useHidden(subtitle)
          )}
        >
          {subtitle}
        </h1>
        <div
          className={classNames(
            "max-sm:w-full lg:w-[885px]",
            useHidden(productLogo)
          )}
        >
          <img
            className="max-sm:h-[72px] lg:h-[190px] justify-start object-fill"
            src={productLogo}
            alt=""
          />
        </div>
        <p
          className={classNames(
            "font-chivo-regular max-sm:text-sm lg:text-lg text-left",
            useHidden(introduction)
          )}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: convertToTags(introduction),
            }}
          />
        </p>

        <SolidButton
          className={classNames(
            "font-chivo-regular text-sm w-[187px] h-[48px]",
            useHidden(button?.buttonLink)
          )}
        >
          <a href={button?.buttonLink}>{button?.buttonCta}</a>
        </SolidButton>
      </div>
    </article>
  );
}
